module.exports = __webpack_public_path__ + "static/img/no-car.8ca4109d.png";